// extracted by mini-css-extract-plugin
module.exports = {"switchAdjust":"FormFieldSwitchPill_switchAdjust__1MUkK"};